<template>
  <section>
    <section class="local-lm-orders-title-mtop">
      <div class="lm-header">
        <h3
          class="subtitle is-5"
          v-t="$t('ListVehicle.title')"
        />
      </div>
      <div class="local-lm-table_space-mTop">
        <b-table
          ref="table"
          :data="registrations"
          :paginated="isPaginated"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :checkbox-position="checkboxPosition"
          :checked-rows.sync="checkedRows"
          :total="totalCount"
          :current-page.sync="currentPage"
          backend-pagination
          per-page="13"
          detail-key="id"
          checkable
          detailed
          hoverable
          narrowed
          class="local-lm-orders-table"
        >
          <template slot-scope="props">
            <b-table-column
              field="id"
              label="l1"
              width="100"
            >
              <template
                slot="header"
              >
                {{ $t('ListVehicle.labelRegistration') }}
              </template>
              <div>
                <p class="lm-default-font">
                  {{ props.row.registration }}
                </p>
              </div>
            </b-table-column>
            <b-table-column
              field="id"
              label="l2"
              width="700"
            >
              <template
                slot="header"
              >
                {{ $t('ListVehicle.labelDriver') }}
              </template>
              <div>
                <p class="lm-default-font">
                  {{ getDriversFullName(props.row.drivers) }}
                </p>
              </div>
            </b-table-column>

            <b-table-column
              label="o1"
              width="30"
              field="props.row.id"
            >
              <template slot="header" />
              <span>
                <b-button
                  icon-right="account-badge-outline"
                  class="local-lm-btn-row"
                  @click.prevent="openModal([ ...props.row ], actions.addDriver)"
                />
              </span>
            </b-table-column>
            <b-table-column
              label="o2"
              width="30"
              field="props.row.id"
            >
              <template slot="header" />
              <span>
                <b-button
                  icon-right="pencil-outline"
                  class="local-lm-btn-row"
                  @click.prevent="openModal([ ...props.row ], actions.editRegistration)"
                />
              </span>
            </b-table-column>
            <b-table-column
              label="o3"
              width="30"
              field="props.row.id"
            >
              <template
                slot="header"
              >
                <b-tooltip
                  :label="$t('ListVehicle.tooltipOp1')"
                  type="is-dark"
                >
                  <b-button
                    icon-right="trash-can-outline"
                    class="local-lm-btn-header"
                    @click.prevent="deleteRegistration(checkedRows)"
                  />
                </b-tooltip>
              </template>
              <span>
                <b-button
                  icon-right="trash-can-outline"
                  class="local-lm-btn-row"
                  @click.prevent="deleteRegistration([ ...props.row ])"
                />
              </span>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </section>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { mixin } from '@/mixins'

export default {
  name: 'ListVehicle',
  mixins: [
    mixin.notifications
  ],
  computed: {
    ...mapGetters('user', [
      'registrations'
    ]),
    ...mapGetters('orders', [
      'actions'
    ]),
    totalCount () {
      return this.$store.getters['user/registrations'].length
    },
    currentPage: {
      get () {
        return this.$store.getters['filters/currentPage']
      },
      set (newVal) {
        this.$eventBus.$emit('onPageChange', newVal)
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('user/getVehicles')
    await this.$store.dispatch('user/getDrivers')

    this.$eventBus.$on('registration', async () => {
      await this.$store.dispatch('user/getVehicles')
    })
  },
  data () {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      paginationPosition: 'top',
      checkboxPosition: 'left',
      checkedRows: []
    }
  },
  methods: {
    async deleteRegistration (registrations) {
      const response = await this.$store.dispatch('user/deleteRegistration', registrations)
      if (!response.level) return this.wrong(this.$t(response.errorText))

      this.sucess(this.$t('Common.success'))
      this.$eventBus.$emit('registration')
    },
    openModal (orders, type) {
      const data = {
        orders,
        type
      }

      this.$store.dispatch('modal/launchModalWithData', data)
    },
    getDriversFullName (drivers) {
      return drivers[0] ? drivers[0].fullName.toUpperCase() : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/miscellaneous/ListVehicle.vue